import type { AnalyticsPayload } from '@/services/analytics';

const UTM_PREFIX = 'utm_';

/* GA4 drops an event parameter whose value passes 100 characters, and it drops it
   whole rather than trimming it, so trim here instead of losing the dimension. */
const MAX_VALUE_LENGTH = 100;

/* Su set utm_source and utm_medium as the fixed pair and left every other parameter
   free, so campaigns invent their own (utm_phone from the WhatsApp bot, for one).
   Collect by prefix rather than from a list: an unmapped parameter is exactly the
   one nobody thought to map. */
export const collectUtmParams = (search: string): AnalyticsPayload => {
  const collected: AnalyticsPayload = {};
  for (const [rawKey, value] of new URLSearchParams(search)) {
    const key = rawKey.toLowerCase();
    if (!key.startsWith(UTM_PREFIX) || value === '' || key in collected) {
      continue;
    }
    collected[key] = value.slice(0, MAX_VALUE_LENGTH);
  }
  return collected;
};
